import React from 'react';

import { createIcon } from '@chakra-ui/react';

import { EColor } from '../Theme';

export const CogIcon = createIcon({
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={EColor.Black}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16.7322 19.9444L16.7323 19.9445C16.7323 19.9445 16.7323 19.9445 16.7324 19.9445C17.1278 20.2991 17.7315 20.2827 18.1071 19.9071L19.9071 18.1071C20.2751 17.7391 20.2993 17.1503 19.9628 16.7533L19.0217 15.6433L19.586 14.2807L21.2517 13.8472C21.6923 13.7326 21.9999 13.3348 21.9999 12.8795L22 11.1001C22 10.6427 21.6897 10.2436 21.2464 10.1308L19.5923 9.71021L19.0293 8.35068L19.9636 7.24566C20.2993 6.84862 20.2748 6.26055 19.9071 5.89289L18.1071 4.09289C17.738 3.72381 17.1471 3.70068 16.7503 4.03978L15.6533 4.97733L14.2427 4.39725L13.809 2.74596C13.6935 2.30642 13.2962 2 12.8418 2H11.0829C10.6286 2 10.2314 2.30619 10.1158 2.7455L9.67233 4.43067L8.32703 4.99777L7.26459 4.05279C6.86888 3.70083 6.26737 3.71841 5.89289 4.09289L4.09289 5.89289C3.73055 6.25524 3.70074 6.83286 4.02387 7.23057L4.95879 8.3813L4.40394 9.74549L2.77274 10.1262C2.32016 10.2318 2 10.6353 2 11.1V12.9C2 13.3509 2.3017 13.746 2.73663 13.8647L4.42845 14.3266L4.99727 15.676L4.05355 16.7346C3.70084 17.1302 3.7181 17.7323 4.09289 18.1071L5.89289 19.9071C6.25565 20.2699 6.83406 20.2993 7.23174 19.9752L8.38223 19.0376L9.71107 19.5843L10.1304 21.2449C10.2426 21.6889 10.642 22 11.1 22H12.9C13.3577 22 13.757 21.6892 13.8694 21.2455L14.2903 19.5838L15.666 19.0141C15.8021 19.1289 15.9546 19.2599 16.1073 19.3928C16.2757 19.5394 16.4323 19.6776 16.5469 19.7793C16.6042 19.8301 16.6508 19.8716 16.6829 19.9003L16.7199 19.9333L16.7294 19.9418L16.7317 19.9439L16.7322 19.9444Z"
        stroke={EColor.Black}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
});
